/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 995e9c83c48f
 */

import * as z from "zod";
import { EventType, EventType$zodSchema } from "./eventtype.js";
import { UriType, UriType$zodSchema } from "./uritype.js";

export type TriggerInfo = {
  id?: string | undefined;
  product_environment_id?: string | undefined;
  uri_type: UriType;
  uri: string;
  event_type?: EventType | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
};

export const TriggerInfo$zodSchema: z.ZodType<TriggerInfo> = z.object({
  created_at: z.iso.datetime({ offset: true }).optional(),
  event_type: EventType$zodSchema.optional().describe(
    "The type of notification event.",
  ),
  id: z.string().optional(),
  product_environment_id: z.string().optional(),
  updated_at: z.iso.datetime({ offset: true }).optional(),
  uri: z.string(),
  uri_type: UriType$zodSchema,
});
